import { http, HttpResponse } from 'msw';
import { mockTruktTmsApiUrl } from '../mocks';
import { InvoiceGetResponse, InvoiceSearchResponse } from '../services/InvoiceService';
import { invoiceSearchResponseItemFactory } from '../factories/invoiceSearchResponseItemFactory';
import { invoiceFactory } from '@trukt/factories/invoiceFactory';

export const handlers = [
  http.get(mockTruktTmsApiUrl('/invoices/:invoiceGuid'), () => {
    return HttpResponse.json<InvoiceGetResponse>(invoiceFactory.build());
  }),
  http.post(mockTruktTmsApiUrl('/invoices/list'), () => {
    return HttpResponse.json<InvoiceSearchResponse>({
      page: 1,
      rows: 3,
      next: true,
      results: invoiceSearchResponseItemFactory.buildList(3),
    });
  }),
  http.put(mockTruktTmsApiUrl('/invoices/:invoiceGuid/payment-release'), () => {
    return HttpResponse.json();
  }),
  http.patch(mockTruktTmsApiUrl('/invoices/:invoiceGuid'), () => {
    return HttpResponse.json();
  }),
];
